<template>
<div class="chapter">
<div class="inner_page">
<p class="C138"><a id="page_15">IVY ALVAREZ</a></p><a id="page_15">
<p class="C144"><em>Auto/biography, or so I was tolde</em></p>
<p class="C145"><em>Mye foote</em></p>
<p class="C109">she pickes mye foote up by the heele</p>
<p class="C109">dragges hir fingre padde</p>
<p class="C110">along myn arche</p>
<p class="C109">&amp; seith unto me</p>
<p class="C109">thow hath a noblewoman’s foote</p>
<p class="C110">(tho I was but a chylde)</p>
<p class="C109">see how hit curveth so highe</p>
<p class="C109">thou wylt never be poore</p>
<p class="C110">thou wylt never stay hiere</p>
<p class="C109">&amp; by thise frekkle hiere</p>
<p class="C109">thou wilt travelle far</p>
<p class="C110">from these mowntaynes &amp; skyes</p>
<p class="C109">hir naile dyde scratche myen lytel skynne</p>
<p class="C109">so myn foote didde curle &amp; shrinke</p>
<p class="C110">lyke a worme evicted from the earthe</p>
<p class="C109">she dyde smile my mother’s mayde</p>
<p class="C109">myn owne nurse</p>
<p class="C110">who didde worke for hir keepe</p>
<p class="C109">theire is no plas to go</p>
<p class="C109">unless t’were</p>
<p class="C110">the bottom o’ the worlde I thoghte</p>
</a><p class="C109"><a id="page_15"></a><a id="page_16">I wolde remaine stedfast hiere</a></p><a id="page_16">
<p class="C109">but the mayde was righte</p>
<p class="C109">&amp; I was wrong</p>
</a><p class="C149"><a id="page_16"><em></em></a><em><a id="page_17">Ant hilles</a></em></p><a id="page_17">
<p class="C109">‘dare never thro stonnes at ant hilles,’ I was tolde</p>
<p class="C109">tharto dryed mudde slops dyde rise from the grounde</p>
<p class="C110">theyr shadows floatynge aboven the dirte</p>
<p class="C109">‘dally not where dwarffes live</p>
<p class="C109">they’rt bolde enoghe to fynde ye</p>
<p class="C110">&amp; takke ye for theyr owne</p>
<p class="C109">&amp; ye wil never bene founde agayn’</p>
</a><p class="C149"><a id="page_17"><em></em></a><em><a id="page_18">Chokke</a></em></p><a id="page_18">
<p class="C109">I was a sea-childe surrownded by watere</p>
<p class="C110">I et sea-snayles, oystres, shrimppe, prawnes, anchoffyshe &amp; squidde,</p>
<p class="C109">mudfyshe, catfyshe, dogfyshe</p>
<p class="C110">I have swallowde a crele of fyshe</p>
<p class="C109">I loved moste the melkfyshe swymminge</p>
<p class="C110">in a brothe of ginger &amp; herbes served with rice or potatose</p>
<p class="C109">but ware thou be for fyshe are fickle thynges, I was tolde</p>
<p class="C110">wyth bonnes that canne chokke a yonge throate</p>
<p class="C109">I was taughte a tricke, a four-fingerde scoope</p>
<p class="C110">a smale ball of rice to pushe downe &amp; thumbe</p>
<p class="C109">dyslodge the bonne past tyrs, feare of chokkynge</p>
<p class="C109">mayhaps live to eat fyshe anothern daye</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 08_IVY_ALVAREZAuto_biography__or_so.vue?212cbc23